import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportPetrolTable() {
  // Store
  const { petrol } = useEnergyPassportDetailsStore()

  return <EnergyPassportDetailsTable title="Энергетический баланс бензина" storeItem={petrol} />
}
